export default __webpack_public_path__ + "static/media/Mesoscopic simulation.2b1b3137.pdf";